<template>
    <div id="cms-block-builder" class="cms-block-builder" :class="cmsPage.customClass">
        <div v-if="$store.state.previewMode === `kiosk`" class="kiosk-height-marker" title="Kiosk Limit 1920px"/>

        <cms-block-menu v-if="!noNavigation && !noHeader && cmsWebsite.menu.block && cmsPage.header.active" v-on="$listeners"
                    :block="cmsWebsite.menu.block" :current-language="currentLanguage" :editable="editable" :block-selection="blockSelection"/>
        <cms-block-renderer v-for="(block, index) in blocks" :key="block.id" :index="index" v-on="$listeners"
                   :block="block" :current-language="currentLanguage" :editable="editable" :block-selection="blockSelection"/>
        <slot></slot>
        <cms-block-footer v-if="!noNavigation && !noFooter && cmsWebsite.footer.block && cmsPage.footer.active" v-on="$listeners"
                  :block="cmsWebsite.footer.block" :current-language="currentLanguage" :editable="editable" :block-selection="blockSelection"/>

        <cms-custom-css item-id="cms-block-builder" :css="cmsPage.css" :bound-item="cmsPage.item"/>
    </div>
</template>

<script>
// cms-block-builder #hot-reload-debug
import CmsBlockFooter from "@/components/editor/rendering/blocks/cms-block-footer.vue";
import CmsBlockMenu from "@/components/editor/rendering/blocks/cms-block-menu.vue";
import CmsBlockRenderer from "@/components/editor/rendering/blocks/cms-block-renderer.vue";
import CmsCustomCss from "@components/editor/rendering/cms-custom-css.vue";

// TODO refactor as cms-page since it's really the page itself
export default {
    name: `cms-block-builder`,
    components: {
        CmsCustomCss,
        CmsBlockMenu,
        CmsBlockFooter,
        CmsBlockRenderer
    },
    props: {
        value: {type: Object}, // blockSelected
        blockSelection: {type: Array},
        noNavigation: {type: Boolean},
        noHeader: {type: Boolean},
        noFooter: {type: Boolean},
        currentLanguage: {type: String, default: `fr`},
        blocks: {type: Array, required: true},
        editable: {type: Boolean}
    },
    computed: {
        blockSelected: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit(`input`, value);
            }
        }
    }
};
</script>

<style scoped lang="scss">
.cms-block-builder {
    padding-bottom: var(--page-padding-bottom);
}

.kiosk-height-marker {
    position: relative;
    top: 1920px;
    width: 100%;
    border-bottom: 3px dashed #1bb5b5;
    z-index: 1;
}

.mobile {
    touch-action: manipulation;
}
</style>
